import qz from "./qz";
import dateFns from "date-fns";

const prepareData = (data, type) => {
  if (type === "sale") {
    const products = data.productList.map(i => {
      return {
        name: i.name,
        qty: i.quantity,
        rate: i.rate,
        total: i.amount
      };
    });
    const formatedDate = dateFns.format(new Date(data.date), "DD/MM/YYYY");

    const meta = {
      subTotal: data.finalTotal,
      grandTotal: data.grandTotal,
      date: formatedDate,
      name: `${data.userData.firstName} ${data.userData.lastName}`,
      discount: data.isPercentage
        ? `${data.discount} %`
        : `Rs. ${data.discount}`
    };
    return {
      products,
      meta
    };
  } else if (type === "chalan") {
    const products = data.chalanItems.map(i => {
      return {
        name: i.name,
        qty: i.quantity,
        rate: i.price,
        total: i.amount
      };
    });
    const formatedDate = dateFns.format(new Date(data.updatedAt), "DD/MM/YYYY");

    const meta = {
      subTotal: data.total,
      grandTotal: data.grandTotal,
      date: formatedDate,
      name: `${data.users.firstName} ${data.users.lastName}`,
      phone: data.users.phone
    };
    return {
      products,
      meta
    };
  } else if (type === "quotation") {
    const products = data.products.map(i => {
      return {
        name: i.name,
        qty: i.quantity,
        rate: i.price,
        total: i.amount
      };
    });
    const formatedDate = dateFns.format(new Date(data.updatedAt), "DD/MM/YYYY");
    const meta = {
      subTotal: data.finalTotal,
      grandTotal: data.grandTotal,
      date: formatedDate,
      name: `${data.user.firstName} ${data.user.lastName}`,
      phone: data.user.phone
    };
    return {
      products,
      meta
    };
  } else if (type === "sale-quotation") {
    const products = data.productMeta.map(i => {
      return {
        name: i.name,
        qty: i.quantity,
        rate: i.price,
        total: i.quantity * i.price
      };
    });
    const formatedDate = dateFns.format(new Date(data.createdAt), "DD/MM/YYYY");
    const meta = {
      subTotal: data.total,
      grandTotal: data.total,
      date: formatedDate,
      name: `${data.user.firstName} ${data.user.lastName}`,
      phone: data.user.phone
    };
    return {
      products,
      meta
    };
  }
};
export function print(sale, type = "sale") {
  const { products, meta } = prepareData(sale, type);
  var config = qz.configs.create("EPSON TM-T82X-S/A");
  var data = [
    "\x1B" + "\x40", // init
    "\x1B" + "\x61" + "\x31", // center align
    "\x1B" + "\x45" + "\x0D", // bold
    "\x1b\x21\x01",
    "\x1b\x21\x11",
    "\x1b\x21\x20",
    "Rajput Electricals" + "\x0A",
    "\x1b\x21\x00",
    "\x1B" + "\x45" + "\x0A",
    "Shop no. 14, 15, Loksangam vihar, P building," + "\x0A", // text and line break
    "opp SVC Bank, aundh, Pune - 7" + "\x0A", // line break
    "Contact: 8237478645, 8237478647, 020 25884004" + "\x0A",
    "\x1B" + "\x61" + "\x30\x0A", // left align   // line break
    meta.date + "\x0A",

    "------------------------------------------------" + "\x0A",
    "Customer: " + meta.name + "\x0A",
    "------------------------------------------------" + "\x0A",
    "#  " +
      "Item" +
      "      \x09\x09" +
      " qty" +
      "  " +
      "Rate" +
      "    " +
      "Total" +
      "\x09" +
      "\x0A"
  ];
  const maxLength = 20;
  products.forEach((item, index) => {
    if (item.name.length > maxLength) {
      data.push(
        index +
          1 +
          Array(3 - (index + 1).toString().length)
            .fill(" ")
            .join("") +
          item.name.substr(0, maxLength) +
          "  " +
          item.qty +
          Array(5 - item.qty.toString().length)
            .fill(" ")
            .join("") +
          +item.rate +
          Array(8 - item.rate.toString().length)
            .fill(" ")
            .join("") +
          item.total +
          "\x09\x0A"
      );
      if (item.name.length - maxLength > maxLength) {
        data.push("   " + item.name.substr(maxLength, maxLength) + "\x0A");
        data.push(
          "   " +
            item.name.substr(maxLength * 2, item.name.length - maxLength * 2) +
            "\x0A"
        );
      } else {
        data.push(
          "   " +
            item.name.substr(maxLength, item.name.length - maxLength) +
            "\x0A"
        );
      }
    } else {
      data.push(
        index +
          1 +
          Array(3 - (index + 1).toString().length)
            .fill(" ")
            .join("") +
          item.name +
          Array(22 - item.name.length)
            .fill(" ")
            .join("") +
          item.qty +
          Array(5 - item.qty.toString().length)
            .fill(" ")
            .join("") +
          item.rate +
          Array(8 - item.rate.toString().length)
            .fill(" ")
            .join("") +
          item.total +
          "\x09\x0A"
      );
    }
  });
  data.push("------------------------------------------------" + "\x0A");
  data.push("\x1B" + "\x45" + "\x0D"); // bold
  data.push("\x09\x09\x09" + "    " + "Subtotal: " + meta.subTotal + "\x0A");
  if (type === "sale") {
    data.push("\x09\x09\x09" + "    " + "Discount: " + meta.discount + "\x0A");
  }
  data.push("\x09\x09\x09" + "    " + "Total   : " + meta.grandTotal + "\x0A");
  data.push("\x1B" + "\x45" + "\x0A"); // unbold
  data.push("\x0A" + "\x0A" + "\x0A" + "\x0A" + "\x0A" + "\x0A" + "\x0A");
  data.push("\x1B" + "\x69");
  data.push("\x10" + "\x14" + "\x01" + "\x00" + "\x05");
  if (qz.websocket.isActive()) {
    qz.print(config, data)
      .then(function() {
        alert("Sent data to printer");
      })
      .catch(function(e) {
        console.log(e);
      });
  } else {
    qz.websocket
      .connect()
      .then(function() {
        qz.print(config, data)
          .then(function() {
            alert("Sent data to printer");
          })
          .catch(function(e) {
            console.log(e);
          });
      })
      .catch(function(e) {
        console.error(e);
        console.log("you are already connected!");
      });
  }
}
